var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: { id: "client_form_modal", "no-close-on-backdrop": true },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c("div", { staticClass: "placeholder" }),
                _c("h2", [_vm._v(_vm._s(_vm.modalTitle))]),
                _c(
                  "button",
                  {
                    staticClass: "close-modal-btn mr-7",
                    attrs: { id: "client_form_modal_close_btn" },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.footerLeftVisible,
                      expression: "footerLeftVisible",
                    },
                  ],
                  staticClass: "footer-left",
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.mode === "edit",
                          expression: "form.mode === 'edit'",
                        },
                      ],
                      staticClass: "bb-btn btn-danger",
                      on: {
                        click: function ($event) {
                          return _vm.deleteClient()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("clientFormModal.deleteBtn")) + " "
                      ),
                    ]
                  ),
                ]
              ),
              _c("div", { staticClass: "footer-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "bb-btn btn-outline",
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("clientFormModal.closeBtn")) + " "
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "bb-btn btn-success",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("clientFormModal.saveBtn")) + " "
                    ),
                  ]
                ),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "modal-body-section" }, [
        _c("div", { staticClass: "modal-inputs-holder" }, [
          _c("div", { staticClass: "form-groups-container" }, [
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("clientFormModal.firstNameInput.label"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.firstName,
                    expression: "form.fields.firstName",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.firstName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "firstName", $event.target.value)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.firstName,
                      expression: "form.errors.firstName",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("clientFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("clientFormModal.lastNameInput.label"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.lastName,
                    expression: "form.fields.lastName",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.lastName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "lastName", $event.target.value)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.lastName,
                      expression: "form.errors.lastName",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("clientFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "form-groups-container" }, [
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("clientFormModal.mobilePhoneInput.label"))
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.mobilePhone,
                    expression: "form.fields.mobilePhone",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.mobilePhone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.form.fields,
                      "mobilePhone",
                      $event.target.value
                    )
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.mobilePhone,
                      expression: "form.errors.mobilePhone",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("clientFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("clientFormModal.phoneInput.label"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.phone,
                    expression: "form.fields.phone",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "phone", $event.target.value)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.phone,
                      expression: "form.errors.phone",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("clientFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "bb-form-group" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("clientFormModal.emailInput.label"))),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.fields.email,
                  expression: "form.fields.email",
                },
              ],
              staticClass: "bb-input",
              attrs: { type: "email" },
              domProps: { value: _vm.form.fields.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.fields, "email", $event.target.value)
                },
              },
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.email,
                    expression: "form.errors.email",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("clientFormModal.validation.error")) + " "
                ),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "bb-form-group" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("clientFormModal.sendNotificationsByInput.label")
                  )
                ),
              ]),
              _c("BBSelect", {
                attrs: { options: _vm.sendNotificationsOptions },
                model: {
                  value: _vm.form.helpers.notificationsSentBy,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.helpers, "notificationsSentBy", $$v)
                  },
                  expression: "form.helpers.notificationsSentBy",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.notificationsSentBy,
                      expression: "form.errors.notificationsSentBy",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("clientFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bb-form-group" },
            [
              _c("BBCheckbox", {
                attrs: {
                  label: _vm.$t(
                    "clientFormModal.notificationsEnabledInput.label"
                  ),
                },
                model: {
                  value: _vm.form.fields.notificationsEnabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "notificationsEnabled", $$v)
                  },
                  expression: "form.fields.notificationsEnabled",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.notificationsEnabled,
                      expression: "form.errors.notificationsEnabled",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("clientFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "modal-body-section" }, [
        _c(
          "div",
          { staticClass: "modal-inputs-holder" },
          [
            _c(
              "v-tabs",
              [
                _c("v-tab", [
                  _vm._v(_vm._s(_vm.$t("clientFormModal.tabs.personalInfo"))),
                ]),
                _c("v-tab", [
                  _vm._v(_vm._s(_vm.$t("clientFormModal.tabs.address"))),
                ]),
                _c("v-tab-item", [
                  _c(
                    "div",
                    { staticClass: "bb-form-group" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("clientFormModal.genderInput.label"))
                        ),
                      ]),
                      _c("BBSelect", {
                        attrs: { options: _vm.genderOptions },
                        model: {
                          value: _vm.form.fields.gender,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.fields, "gender", $$v)
                          },
                          expression: "form.fields.gender",
                        },
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.errors.gender,
                              expression: "form.errors.gender",
                            },
                          ],
                          staticClass: "bb-invalid-feedback",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("clientFormModal.validation.error")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("clientFormModal.birthdayInput.label"))
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "birthday-inputs" },
                      [
                        _c("BBSelect", {
                          attrs: {
                            placeholder: _vm.$t(
                              "clientFormModal.birthdayInput.monthPlaceholder"
                            ),
                            options: _vm.monthOptions,
                          },
                          model: {
                            value: _vm.form.helpers.birthday.month,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.helpers.birthday, "month", $$v)
                            },
                            expression: "form.helpers.birthday.month",
                          },
                        }),
                        _c("BBSelect", {
                          attrs: {
                            placeholder: _vm.$t(
                              "clientFormModal.birthdayInput.dayPlaceholder"
                            ),
                            options: _vm.dayOptions,
                          },
                          model: {
                            value: _vm.form.helpers.birthday.day,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.helpers.birthday, "day", $$v)
                            },
                            expression: "form.helpers.birthday.day",
                          },
                        }),
                        _c("BBSelect", {
                          attrs: {
                            placeholder: _vm.$t(
                              "clientFormModal.birthdayInput.yearPlaceholder"
                            ),
                            options: _vm.yearOptions,
                          },
                          model: {
                            value: _vm.form.helpers.birthday.year,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.helpers.birthday, "year", $$v)
                            },
                            expression: "form.helpers.birthday.year",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.birthday,
                            expression: "form.errors.birthday",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("clientFormModal.validation.error")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bb-form-group" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("clientFormModal.notesInput.label"))
                        ),
                      ]),
                      _c("b-form-textarea", {
                        staticClass: "bb-textarea",
                        attrs: { rows: "3" },
                        model: {
                          value: _vm.form.fields.notes,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.fields, "notes", $$v)
                          },
                          expression: "form.fields.notes",
                        },
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.errors.notes,
                              expression: "form.errors.notes",
                            },
                          ],
                          staticClass: "bb-invalid-feedback",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("clientFormModal.validation.error")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "bb-form-group" },
                    [
                      _c("BBCheckbox", {
                        attrs: {
                          disabled: !_vm.form.fields.notes,
                          label: _vm.$t(
                            "clientFormModal.displayNotesInput.label"
                          ),
                        },
                        model: {
                          value: _vm.form.fields.displayNotes,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.fields, "displayNotes", $$v)
                          },
                          expression: "form.fields.displayNotes",
                        },
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.errors.displayNotes,
                              expression: "form.errors.displayNotes",
                            },
                          ],
                          staticClass: "bb-invalid-feedback",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("clientFormModal.validation.error")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("v-tab-item", [
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("clientFormModal.addressInput.label"))
                      ),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.address,
                          expression: "form.fields.address",
                        },
                      ],
                      staticClass: "bb-input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.fields.address },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "address",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.address,
                            expression: "form.errors.address",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("clientFormModal.validation.error")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "form-groups-container" }, [
                    _c("div", { staticClass: "bb-form-group" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("clientFormModal.cityInput.label"))
                        ),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.fields.city,
                            expression: "form.fields.city",
                          },
                        ],
                        staticClass: "bb-input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.form.fields.city },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form.fields,
                              "city",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.errors.city,
                              expression: "form.errors.city",
                            },
                          ],
                          staticClass: "bb-invalid-feedback",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("clientFormModal.validation.error")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "bb-form-group" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("clientFormModal.stateInput.label"))
                        ),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.fields.state,
                            expression: "form.fields.state",
                          },
                        ],
                        staticClass: "bb-input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.form.fields.state },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form.fields,
                              "state",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.errors.state,
                              expression: "form.errors.state",
                            },
                          ],
                          staticClass: "bb-invalid-feedback",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("clientFormModal.validation.error")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("clientFormModal.zipCodeInput.label"))
                      ),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.zipCode,
                          expression: "form.fields.zipCode",
                        },
                      ],
                      staticClass: "bb-input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.fields.zipCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "zipCode",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.zipCode,
                            expression: "form.errors.zipCode",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("clientFormModal.validation.error")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "mobile-additional-info-container" }, [
              _c("div", { staticClass: "mobile-section" }, [
                _c("h3", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "clientFormModal.mobileSection.notesSection.title"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "bb-form-group" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "clientFormModal.mobileSection.notesSection.notesInput.label"
                          )
                        )
                      ),
                    ]),
                    _c("b-form-textarea", {
                      staticClass: "bb-textarea",
                      attrs: { rows: "3" },
                      model: {
                        value: _vm.form.fields.notes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.fields, "notes", $$v)
                        },
                        expression: "form.fields.notes",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.notes,
                            expression: "form.errors.notes",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("clientFormModal.validation.error")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "bb-form-group" },
                  [
                    _c("BBCheckbox", {
                      attrs: {
                        disabled: !_vm.form.fields.notes,
                        label: _vm.$t(
                          "clientFormModal.mobileSection.notesSection.displayNotesInput.label"
                        ),
                      },
                      model: {
                        value: _vm.form.fields.displayNotes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.fields, "displayNotes", $$v)
                        },
                        expression: "form.fields.displayNotes",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.displayNotes,
                            expression: "form.errors.displayNotes",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("clientFormModal.validation.error")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "mobile-section" }, [
                _c("h3", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "clientFormModal.mobileSection.additionalInfoSection.title"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "modal-trigger",
                    on: {
                      click: function ($event) {
                        return _vm.openPersonalInfoModal()
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "clientFormModal.mobileSection.additionalInfoSection.personalInfoBtn"
                          )
                        )
                      ),
                    ]),
                    _c("i", { staticClass: "la la-angle-right" }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "modal-trigger",
                    on: {
                      click: function ($event) {
                        return _vm.openAddressDetailsModal()
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "clientFormModal.mobileSection.additionalInfoSection.addressDetailsBtn"
                          )
                        )
                      ),
                    ]),
                    _c("i", { staticClass: "la la-angle-right" }),
                  ]
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c("PersonalInfoMobileModal", {
        ref: "personalInfoMobileModal",
        attrs: {
          data: {
            birthday: _vm.form.helpers.birthday,
            gender: _vm.form.fields.gender,
          },
        },
        on: { dataChanged: _vm.personalInfoChanged },
      }),
      _c("AddressDetailsMobileModal", {
        ref: "addressDetailsMobileModal",
        attrs: {
          data: {
            address: _vm.form.fields.address,
            city: _vm.form.fields.city,
            state: _vm.form.fields.state,
            zipCode: _vm.form.fields.zipCode,
          },
        },
        on: { dataChanged: _vm.addressDetailsChanged },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }